// usePaymentData.ts
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { TariffRule } from '../types/interfaces'
import { getApi } from '../../api/api'
import { selectAuthToken } from '../../store/slices/authSlice'
import { closePayment } from '../../store/slices/paymentSlice'
import { CLUSTER_ROUTE } from '../../common/utils/constants'

export const usePaymentData = (clusterId: number) => {
  const [loading, setLoading] = useState(true)
  const [tariff, setTariff] = useState<TariffRule | undefined>()
  const [monthlyPrice, setMonthlyPrice] = useState<number>(0)
  const [agreement, setAgreement] = useState<string>('')
  const [error, setError] = useState<string | null>(null)
  const token = useSelector(selectAuthToken)
  const api = getApi()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    if (!clusterId || !token) return

    const fetchData = async () => {
      try {
        setLoading(true)
        setError(null)
        const clusterData = await api.getCluster(clusterId)
        setTariff(clusterData.tariff)
        setAgreement(clusterData.agreement || '')

        if (clusterData.tariff) {
          const basePrice = clusterData.tariff.specialPrice || clusterData.tariff.basePrice
          setMonthlyPrice(basePrice)
        } else {
          setMonthlyPrice(clusterData.billing?.monthlyPrice || 0)
        }
      } catch (err: any) {
        setError('Не удалось загрузить данные кластера')
        dispatch(closePayment())
        navigate(CLUSTER_ROUTE)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [clusterId, api, token])

  return { loading, tariff, monthlyPrice, agreement, error }
}
